import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function baixarModeloExcel(nomeArquivo: string, colunas: readonly string[]): void {
  const ws = XLSX.utils.aoa_to_sheet([Array.from(colunas)]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Modelo');
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, nomeArquivo);
}

const numeroProcesso = ['Número do processo'] as const;

export const MODELOS_EXCEL_RELATORIO = {
  audienciasPresenciais: {
    arquivo: 'modelo-audiencias-presenciais.xlsx',
    colunas: ['Tipo de audiência', 'Número/Protocolo', 'Data'],
  },
  audienciasRemotas: {
    arquivo: 'modelo-audiencias-remotas.xlsx',
    colunas: ['Tipo de audiência', 'Número do processo', 'Data'],
  },
  autorNatureza: {
    arquivo: 'modelo-autor-natureza.xlsx',
    colunas: ['Autor', 'Natureza da ação'],
  },
  contestacao: {
    arquivo: 'modelo-contestacao.xlsx',
    colunas: numeroProcesso,
  },
  reconvencao: {
    arquivo: 'modelo-reconvencao.xlsx',
    colunas: numeroProcesso,
  },
  replica: {
    arquivo: 'modelo-replica.xlsx',
    colunas: numeroProcesso,
  },
  manifestacao: {
    arquivo: 'modelo-manifestacao.xlsx',
    colunas: numeroProcesso,
  },
  razoesFinais: {
    arquivo: 'modelo-razoes-finais.xlsx',
    colunas: numeroProcesso,
  },
  recursos: {
    arquivo: 'modelo-recursos.xlsx',
    colunas: numeroProcesso,
  },
  honorariosSentenca: {
    arquivo: 'modelo-honorarios-sentenca.xlsx',
    colunas: numeroProcesso,
  },
  honorariosCumprimento: {
    arquivo: 'modelo-honorarios-cumprimento.xlsx',
    colunas: numeroProcesso,
  },
  oficiosRequisitorios: {
    arquivo: 'modelo-oficios-requisitorios.xlsx',
    colunas: numeroProcesso,
  },
  oficiosDemais: {
    arquivo: 'modelo-oficios-demais.xlsx',
    colunas: numeroProcesso,
  },
  designacaoProcessos: {
    arquivo: 'modelo-designacao-processos.xlsx',
    colunas: ['Tipo de peça', 'Número do processo', 'Defensoria'],
  },
  designacaoAudiencias: {
    arquivo: 'modelo-designacao-audiencias.xlsx',
    colunas: ['Tipo de audiência', 'Número do processo', 'Data', 'Defensoria'],
  },
  outrosProcedimentos: {
    arquivo: 'modelo-outros-procedimentos.xlsx',
    colunas: numeroProcesso,
  },
  outrasManifestacoes: {
    arquivo: 'modelo-outras-manifestacoes.xlsx',
    colunas: numeroProcesso,
  },
  ciencia: {
    arquivo: 'modelo-ciencia.xlsx',
    colunas: numeroProcesso,
  },
} as const;
